import React from 'react';
import FuseAnimate from '@fuse/core/FuseAnimate';
import { useForm } from '@fuse/hooks';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';
import HeaderAuth from 'app/main/pages/auth/headerAuth/HeaderAuth'; 
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import { RiLockPasswordFill } from "react-icons/ri";
import axios from 'axios';
import  toast, { Toaster } from 'react-hot-toast';
import { useHistory } from "react-router-dom";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(theme => ({
	root: {
		background: `radial-gradient(${theme.palette.background.paper} 100%, ${theme.palette.background.paper} 100%)`,
		color: theme.palette.primary.contrastText
	},
	containerPassword: {
		boxShadow: 'none',
		maxWidth: '600px',
		margin: 'auto',
		fontSize: '14px'
	},
	logo: {
		width: '100%',
		marginBottom: '12px'
	},
	logoLock:{
		width: '64px',
		margin: 'auto',
	},
	greyBox: {
		padding: '20px 20px',
		background: '#f9f9f9',
		border: 'solid thin #ccc',
		marginBottom: '35px',
		width: '100%',
		textAlign: 'center',
	},
	notif: {
		marginBottom: '10px',
		fontWeight: 'bold',
		fontSize: '14px',
		color: '#575757',
		'&:last-child':{
			marginBottom: '0px',
		}
	},
	reset:{
		fontSize:'3rem',
		fontWeight:'bold',
		color: theme.palette.scaiPro.primary,
	},
	goBackLogin:{
		color: `${theme.palette.scaiPro.primary}!important`,
	},
	icon:{
		color: '#6581c2',
		width: '64px',
		height: '64px',
		margin: 'auto',
		display: 'block',
	},
	toasterStyle:{
        marginTop:'100px',
    },
}));

function ResetPasswordPage() {
	const classes = useStyles();
	let history = useHistory();
	const {t} = useTranslation('auth');
	let tokenUrl  = window.location.search.split('=')[1]
	const { form, handleChange, resetForm } = useForm({
		password: '',
		passwordConfirm: '',
		showPassword: false,
	});

	function isFormValid() {
		return (
			form.password.length > 7 &&
			form.password === form.passwordConfirm
		);
	}

	function handleSubmit(ev) {
		resetForm();
		ev.preventDefault();

		let send_data = {
			"token": tokenUrl, 
			"newPw": form.password, 
			"cnfPw": form.passwordConfirm
		}
		return new Promise((resolve, reject) => {
			axios.post(process.env.REACT_APP_SERVER + '/api/auth/set-new-password', send_data).then(response => {
				if (response.data) {
					resolve(response.data);
					toast.success(t('password_updated_success'));
					setTimeout(()=>{
						history.push({pathname:'/login'})
					},2500) 
				} else {
					reject(response.data.error);
					toast.error(t('password_not_updated'));
				}
			});
		});
		
	}

	const [values, setValues] = React.useState({
		showPassword: false,
		showPasswordConfirm: false,
	  });

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const handleClickShowPasswordConfirm = () => {
		setValues({ ...values, showPasswordConfirm: !values.showPasswordConfirm });
	};

	const handleMouseDownPasswordConfirm = (event) => {
		event.preventDefault();
	};
	
	return (
		<>
			<Toaster
                toastOptions={{
                    className:classes.toasterStyle,
                }}
             />
			<HeaderAuth />
			<div className={clsx(classes.root, 'flex flex-col flex-auto flex-shrink-0 items-center justify-center p-32')}>
				<div className="flex flex-col items-center justify-center w-full">
					<FuseAnimate /*animation="transition.expandIn"*/>
						<Card className={clsx(classes.containerPassword, 'w-full max-w-640')}>
							<CardContent className="flex flex-col items-center justify-center p-32">
								
								{/* <img className={classes.logo} src="assets/images/logos/scai_logo.svg" alt="logo" /> */}
								
								<span className={clsx("flex justify-center text-center w-full mt-16", classes.reset)}>
									{t('set_new_password')}
								</span>

								<div className="w-128 m-32">
									<RiLockPasswordFill className={classes.icon} />
								</div>

								<div className={classes.greyBox}>
									<p className={classes.notif}>{t('password_requirements')}</p>
								</div>

								<form
									name="recoverForm"
									noValidate
									className="flex flex-col justify-center w-full"
									onSubmit={handleSubmit}
								>
									<TextField
										className="mb-16"
										label={t('password')}
										name="password"
										value={form.password}
										onChange={handleChange}
										variant="outlined"
										required
										fullWidth
										InputProps={{
											endAdornment:(
												<InputAdornment position="end">
												  <IconButton
													aria-label="toggle password visibility"
													onClick={handleClickShowPassword}
													onMouseDown={handleMouseDownPassword}
												  >
													{values.showPassword ? <Visibility /> : <VisibilityOff />}
												  </IconButton>
												</InputAdornment>
											)

										}}
										type={values.showPassword ? 'text' : 'password'}
									/>

									<TextField
										className="mb-16"
										label={t('password_confirm')}
										name="passwordConfirm"
										value={form.passwordConfirm}
										onChange={handleChange}
										variant="outlined"
										required
										fullWidth
										InputProps={{
											endAdornment:(
												<InputAdornment position="end">
												  <IconButton
													aria-label="toggle password visibility"
													onClick={handleClickShowPasswordConfirm}
													onMouseDown={handleMouseDownPasswordConfirm}
												  >
													{values.showPasswordConfirm ? <Visibility /> : <VisibilityOff />}
												  </IconButton>
												</InputAdornment>
											)

										}}
										type={values.showPasswordConfirm ? 'text' : 'password'}
									/> 

									<Button
										variant="contained"
										color="primary"
										className="w-224 mx-auto mt-16 bt-update"
										aria-label="Reset"
										disabled={!isFormValid()}
										type="submit"
									>
										{t('submit')}
									</Button>
								</form>

								<div className="flex flex-col items-center justify-center pt-32 pb-24">
									<Link className={clsx("font-medium", classes.goBackLogin)} to="/login">
										{t('go_back_to_login_page')}
									</Link>
								</div>
							</CardContent>
						</Card>
					</FuseAnimate>
				</div>
			</div>
		</>
	);
}

export default ResetPasswordPage;